import { createSlice } from '@reduxjs/toolkit';
import { getWithoutDriverRevenue, getWithoutDriverRevenuetTotal, getWithoutDriverRevenueCount } from './actions';

const initialState = {
  data: {},
  total: null,
  count: null,
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const withoutDriverRevenue = createSlice({
  name: 'withoutDriverRevenue',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWithoutDriverRevenue.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
        state.total = null;
        state.count = null;
      })
      .addCase(getWithoutDriverRevenue.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getWithoutDriverRevenue.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.data = action.payload;
        state.total = action.payload.total;
        state.count = action.payload.count;
      })
      .addCase(getWithoutDriverRevenuetTotal.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.total = null;
      })
      .addCase(getWithoutDriverRevenuetTotal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getWithoutDriverRevenuetTotal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.total = action.payload;
      })
      .addCase(getWithoutDriverRevenueCount.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.count = null;
      })
      .addCase(getWithoutDriverRevenueCount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getWithoutDriverRevenueCount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.count = action.payload;
      });
  },
});

export default withoutDriverRevenue.reducer;
